<template lang="pug">
    v-stepper(v-model="step")
        v-stepper-header
            v-stepper-step( :complete="completeGeneral" step="1" :color="completeGeneral && this.date ? 'green' : 'primary'" ) Info. General
            v-divider
            v-stepper-step( :complete="completeTaxable" step="2" :color="completeTaxable ? 'green' : 'primary'" ) Rentas Imponibles
            v-divider
            //v-stepper-step( :complete="completeAPV" step="3" :color="completeAPV ? 'green' : 'primary'" ) Info. APV
            //v-divider
            v-stepper-step( :complete="completeAFC" step="4" :color="completeAFC ? 'green' : 'primary'") Info. AFC
            v-stepper-items
        v-stepper-content( class="elevation-0" step="1" )
            v-flex( xs11 sm5 )
                v-dialog.ml-5.mt-4.mb-2(
                    ref="dialog"
                    v-model="modal"
                    
                    lazy
                    full-width
                    width="290px"
                    )
                    v-text-field(
                        slot="activator"
                        v-model="date"
                        label="Indique Período"
                        prepend-icon="event"
                        readonly
                        )
                    v-date-picker(v-model="date" type="month" scrollable locale)
                    v-spacer
                    //v-btn(flat color="primary" @click="modal = false") Cancelar
                    //v-btn(flat color="primary" @click="submitDate") Aceptar
            crud-form( v-bind="generalFormProps" @calculate="calculateGeneralForm" )
            v-btn( color='success' large @click='fetchPreviousMonth' ) cargar mes anterior &nbsp;
                v-icon cloud_download
            v-btn.ma-4( color="primary" large @click="goToStepTwo") Siguiente
                v-icon navigate_next
        v-stepper-content( class="elevation-0" step="2" )
            crud-form( v-bind="taxableFormProps" @calculate="calculateTaxableForm" )
            v-btn.ma-4( dark large @click="goBackToStepOne") Anterior
                v-icon navigate_before
            v-btn.ma-4( color="primary" large @click="goToStepThree") Siguiente
                v-icon navigate_next
        v-stepper-content( class="elevation-0" step="3" )
            crud-form( v-bind="apvFormProps" @calculate="calculateAPVForm" )
            v-btn.ma-4( dark large @click="goBackToStepTwo") Anterior
                v-icon navigate_before
            v-btn.ma-4( color="primary" large @click="goToStepFour") Siguiente
                v-icon navigate_next
        v-stepper-content( class="elevation-0" step="4" )
            v-alert( color='info' icon='info' :value='true' )
                h1.title.text-uppercase.mb-2 Seguro de cesantía por tipo de contrato
                h4.body-2.text-uppercase C.I. = Contrato Indefinido
                h4.body-2.text-uppercase C.F. = Contrato Fijo
            //- v-toolbar( color="blue darken-4" dark sticky flat )
                v-toolbar-title C.I. = Contrato Indefinido
                v-spacer
                v-toolbar-title C.F. = Contrato Fijo
                v-spacer
            crud-form( v-bind="afcFormProps" @calculate="calculateAFCForm" )
            v-btn.ma-4( dark large @click="goBackToStepThree") Anterior
                v-icon navigate_before
            v-btn.ma-4( color="primary" large @click="submitCreateIndicators") Crear
                v-icon navigate_next
</template>

<script>
//-
import { mapActions, mapState } from 'vuex'
import { CrudForm } from '@/components/reusable_components'
import {
    FieldsAFC,
    FieldsAPV,
    FieldsGeneralInfo,
    FieldsTaxableRent,
} from './fields'
import { generatePrevisionIndicator } from '@/services/api/previsionIndicators'
import IndicatorModel from '@/models/HumanResource/HrIndicator'
//-
export default {
    name: 'create-prevision-indicators',
    // props: {},
    data: function() {
        return {
            date: null,
            menu: false,
            modal: false,
            step: 1,
            completeGeneral: false,
            completeTaxable: false,
            completeAPV: false,
            completeAFC: false,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        generalFormProps() {
            return {
                fields: FieldsGeneralInfo,
                noButtons: true,
                ref: 'refGeneralForm',
            }
        },
        taxableFormProps() {
            return {
                fields: FieldsTaxableRent,
                noButtons: true,
                ref: 'refTaxableForm',
            }
        },
        apvFormProps() {
            return {
                fields: FieldsAPV,
                noButtons: true,
                ref: 'refAPVForm',
            }
        },
        afcFormProps() {
            return {
                fields: FieldsAFC,
                noButtons: true,
                ref: 'refAFCForm',
            }
        },
    },
    methods: {

        fetchPreviousMonth() {

            //
            const periodYear = Number(this.date.split('-').shift())
            const periodMonth = Number(this.date.split('-').pop()) - 1

            //
            return IndicatorModel
                .where('period_year', periodMonth ? periodYear : periodYear - 1)
                .where('period_month', periodMonth || 12)
                .get()
                .then(this.setPreviousMonth)
        },

        setPreviousMonth(res) {

            //
            if (res.data.length > 0) {

                //
                const previousMonth = res.data.slice().shift()

                //
                this.$refs.refGeneralForm.vmodels.uf = previousMonth.uf
                this.$refs.refGeneralForm.vmodels.uta = previousMonth.uta
                this.$refs.refGeneralForm.vmodels.utm = previousMonth.utm

                //
                this.$refs.refTaxableForm.vmodels.max_afp_uf = previousMonth.max_afp_uf
                this.$refs.refTaxableForm.vmodels.max_fonasa_uf = previousMonth.max_fonasa_uf
                this.$refs.refTaxableForm.vmodels.max_unemployment_insurance_uf = previousMonth.max_unemployment_insurance_uf
                this.$refs.refTaxableForm.vmodels.max_health_uf = previousMonth.max_health_uf
                this.$refs.refTaxableForm.vmodels.imm = previousMonth.imm
                this.$refs.refTaxableForm.vmodels.max_apv_monthly_uf = previousMonth.max_apv_monthly_uf
                this.$refs.refTaxableForm.vmodels.max_apv_yearly_uf = previousMonth.max_apv_yearly_uf

                //
                this.$refs.refAFCForm.vmodels.porc_afc_employer_undefined_contract = previousMonth.porc_afc_employer_undefined_contract
                this.$refs.refAFCForm.vmodels.porc_afc_worker_undefined_contract = previousMonth.porc_afc_worker_undefined_contract
                this.$refs.refAFCForm.vmodels.porc_afc_employer_fixed_contract = previousMonth.porc_afc_employer_fixed_contract
                this.$refs.refAFCForm.vmodels.porc_afc_worker_fixed_contract = previousMonth.porc_afc_worker_fixed_contract
                this.$refs.refAFCForm.vmodels.porc_afc_employer_undefined_contract_min_eleven_years = previousMonth.porc_afc_employer_undefined_contract_min_eleven_years
                this.$refs.refAFCForm.vmodels.porc_afc_worker_undefined_contract_min_eleven_years = previousMonth.porc_afc_worker_undefined_contract_min_eleven_years
            } else {

                this.$refs.refGeneralForm.vmodels.uf = 0
                this.$refs.refGeneralForm.vmodels.uta = 0
                this.$refs.refGeneralForm.vmodels.utm = 0
                this.$refs.refTaxableForm.vmodels.max_afp_uf = 0
                this.$refs.refTaxableForm.vmodels.max_fonasa_uf = 0
                this.$refs.refTaxableForm.vmodels.max_unemployment_insurance_uf = 0
                this.$refs.refTaxableForm.vmodels.max_health_uf = 0
                this.$refs.refTaxableForm.vmodels.imm = 0
                this.$refs.refTaxableForm.vmodels.max_apv_monthly_uf = 0
                this.$refs.refTaxableForm.vmodels.max_apv_yearly_uf = 0
                this.$refs.refAFCForm.vmodels.porc_afc_employer_undefined_contract = 0
                this.$refs.refAFCForm.vmodels.porc_afc_worker_undefined_contract = 0
                this.$refs.refAFCForm.vmodels.porc_afc_employer_fixed_contract = 0
                this.$refs.refAFCForm.vmodels.porc_afc_worker_fixed_contract = 0
                this.$refs.refAFCForm.vmodels.porc_afc_employer_undefined_contract_min_eleven_years = 0
                this.$refs.refAFCForm.vmodels.porc_afc_worker_undefined_contract_min_eleven_years = 0
            }
        },

        // -- UI Modification
        submitDate: function() {
            this.$refs.dialog.save(this.date)
            this.data = this.$refs.dialog.$options.propsData.returnValue
        },
        submitCreateIndicators: function() {
            let vmodelsAFC = this.$refs.refAFCForm.vmodels
            if (
                vmodelsAFC.porc_afc_employer_undefined_contract !== '' &&
                vmodelsAFC.porc_afc_worker_undefined_contract !== '' &&
                vmodelsAFC.porc_afc_employer_fixed_contract !== '' &&
                vmodelsAFC.porc_afc_worker_fixed_contract !== '' &&
                vmodelsAFC.porc_afc_employer_undefined_contract_min_eleven_years !==
                    '' &&
                vmodelsAFC.porc_afc_worker_undefined_contract_min_eleven_years !==
                    ''
            ) {
                this.resetSnackbarState()
                this.setMessageConfirmSnack('Crear')
                let payload = this.fillSnack(
                    'warning',
                    '¿Desea crear índices previsionales?',
                    ''
                )
                this.initSnackbar(payload)
            } else {
                this.showSnackbar(
                    'info',
                    'Acción inválida',
                    'Complete todos los campos'
                )
            }
        },
        // -- Navegations on Steppers
        goToStepTwo: function() {
            let vmodelsGeneral = this.$refs.refGeneralForm.vmodels
            if (
                this.date !== null &&
                vmodelsGeneral.uf !== '' &&
                vmodelsGeneral.uta !== '' &&
                vmodelsGeneral.utm !== ''
            ) {
                this.step = 2
            } else if (this.date === null || this.date === '') {
                this.showSnackbar('info', 'Acción inválida', 'Ingrese período')
            } else {
                this.showSnackbar(
                    'info',
                    'Acción inválida',
                    'Complete todos los campos'
                )
            }
        },
        goToStepThree: function() {
            let vmodelsTaxableRent = this.$refs.refTaxableForm.vmodels
            if (
                vmodelsTaxableRent.max_afp_uf !== '' &&
                vmodelsTaxableRent.max_fonasa_uf !== '' &&
                vmodelsTaxableRent.max_health_uf !== '' &&
                vmodelsTaxableRent.max_unemployment_insurance_uf !== '' &&
                vmodelsTaxableRent.imm !== '' &&
                vmodelsTaxableRent.max_apv_monthly_uf !== '' &&
                vmodelsTaxableRent.max_apv_yearly_uf !== ''
            ) {
                this.step = 4
            } else {
                this.showSnackbar(
                    'info',
                    'Acción inválida',
                    'Complete todos los campos'
                )
            }
        },
        goToStepFour: function() {
            let vmodelsAPV = this.$refs.refAPVForm.vmodels
            if (
                vmodelsAPV.max_apv_monthly_uf !== '' &&
                vmodelsAPV.max_apv_yearly_uf !== ''
            ) {
                this.step = 4
            } else {
                this.showSnackbar(
                    'info',
                    'Acción inválida',
                    'Complete todos los campos'
                )
            }
        },
        goBackToStepOne() {
            this.step = 1
        },
        goBackToStepTwo() {
            this.step = 2
        },
        goBackToStepThree() {
            this.step = 2
        },
        // -- Data fetching
        // -- Data handling and transformations
        // -- Calculate methods for Validations
        calculateGeneralForm: function(event) {
            this.completeGeneral = this.$refs.refGeneralForm.$refs.form.validate()
        },
        calculateTaxableForm: function() {
            this.completeTaxable = this.$refs.refTaxableForm.$refs.form.validate()
        },
        calculateAPVForm: function() {
            this.completeAPV = this.$refs.refAPVForm.$refs.form.validate()
        },
        calculateAFCForm: function() {
            this.completeAFC = this.$refs.refAFCForm.$refs.form.validate()
        },
        // -- Validations and Error handling
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        // -- Other functions
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        async responseConfirm(val) {
            //-
            if (val === 'Crear') {
                this.resetSnackbarState()
                let obj = {}
                // -- Datos Generales
                let vmodelsGeneral = this.$refs.refGeneralForm.vmodels
                obj.uf = vmodelsGeneral.uf
                obj.utm = vmodelsGeneral.utm
                obj.uta = vmodelsGeneral.uta
                // -- Rentas Imponibles
                let vmodelsTaxableRent = this.$refs.refTaxableForm.vmodels
                obj.max_afp_uf = vmodelsTaxableRent.max_afp_uf
                obj.max_fonasa_uf = vmodelsTaxableRent.max_fonasa_uf
                obj.max_health_uf = vmodelsTaxableRent.max_health_uf
                obj.max_unemployment_insurance_uf =
                    vmodelsTaxableRent.max_unemployment_insurance_uf
                obj.imm = vmodelsTaxableRent.imm
                obj.max_apv_monthly_uf = vmodelsTaxableRent.max_apv_monthly_uf
                obj.max_apv_yearly_uf = vmodelsTaxableRent.max_apv_yearly_uf
                // -- APV
                //let vmodelsAPV = this.$refs.refAPVForm.vmodels
                //obj.max_apv_monthly_uf = vmodelsAPV.max_apv_monthly_uf
                //obj.max_apv_yearly_uf = vmodelsAPV.max_apv_yearly_uf
                // -- AFC
                let vmodelsAFC = this.$refs.refAFCForm.vmodels
                obj.porc_afc_employer_undefined_contract =
                    vmodelsAFC.porc_afc_employer_undefined_contract
                obj.porc_afc_worker_undefined_contract =
                    vmodelsAFC.porc_afc_worker_undefined_contract
                obj.porc_afc_employer_fixed_contract =
                    vmodelsAFC.porc_afc_employer_fixed_contract
                obj.porc_afc_worker_fixed_contract =
                    vmodelsAFC.porc_afc_worker_fixed_contract
                obj.porc_afc_employer_undefined_contract_min_eleven_years =
                    vmodelsAFC.porc_afc_employer_undefined_contract_min_eleven_years
                obj.porc_afc_worker_undefined_contract_min_eleven_years =
                    vmodelsAFC.porc_afc_worker_undefined_contract_min_eleven_years
                // -- Period Year & Month
                let periodYear = parseFloat(this.date.substr(0, 4))
                let periodMonth = parseFloat(this.date.substr(5, 2))
                let response = await generatePrevisionIndicator(
                    obj,
                    periodYear,
                    periodMonth
                )
                //-
                if (response.status == 'success') {
                    let payload = this.fillSnack(
                        'success',
                        'Indicadores previsionales creados con éxito',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$router.push('/prevision_indicators')
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    mounted: function() {
        this.setTitleTopBar('Crear Indicadores Previsionales')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('EDIT_PREVISION_INDICATOR')) ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>